import { render, staticRenderFns } from "./quickUserAdmin.vue?vue&type=template&id=c305e8ac&scoped=true&"
import script from "./quickUserAdmin.vue?vue&type=script&lang=js&"
export * from "./quickUserAdmin.vue?vue&type=script&lang=js&"
import style0 from "./quickUserAdmin.vue?vue&type=style&index=0&id=c305e8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c305e8ac",
  null
  
)

export default component.exports